import React from 'react';
import { connect } from 'react-redux';
import ViewerTable from '../components/schedule/viewer_table';
import LoadingIndicator from '../components/common/loading_indicator';
import ControlsMenu from '../components/schedule/controls_menu';
import LayersMenu from '../components/schedule/layers_menu';
import SelectDropdown from '../components/common/select_dropdown';
import actions from '../actions/index';
import viewerSelector from '../selectors/viewer_selector';

const mapStateToProps = (state) => {
  return viewerSelector(state);
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    dispatch: dispatch,
    handleMount: () => {
      dispatch(actions.requestSchedules(props.data));
    },

    handleScheduleChange: (previous, current) => {
      dispatch(actions.changeSchedule(
        current.data.id
      ));
    },

    handleViewerLayoutChange: (previous, current) => {
      dispatch(actions.selectViewerLayout(
        current.data.id
      ));
    },

    handleCellChange: (id, element, cell, selected) => {
      dispatch(actions.selectViewerCell(
        id,
        cell.scheduledMeeting.id,
        selected
      ));
    },

    handleColumnClick: (id, element, column, selected) => {
      dispatch(actions.selectViewerColumn(
        column.index,
        column.name,
        column.value,
        selected
      ));
    },

    handleSubColumnClick: (id, element, subColumn, selected) => {
      // disable this event for now - we don't support subcolumn
      // selection in the inspector.
      
      // dispatch(actions.selectViewerSubColumn(
      //   subColumn.column.index,
      //   subColumn.name,
      //   subColumn.value,
      //   selected
      // ));
    },

    handleColumnCloseClick: (column) => {
      dispatch(actions.hideViewerColumn(
        column.index,
        column.name,
        column.value
      ));
    },

    handleUnhideColumnsClick: (column) => {
      dispatch(actions.unHideViewerColumns());
    },

    handleControlsMenuItemChange: (previous, current) => {
      dispatch(actions.selectControlsMenuItem(
        current.data.id, 
        current.selected
      ));
    },

    handleTeacherSelect: (previous, current) => {
      dispatch(actions.selectTeacher(
        current.data.id, 
        current.selected
      ));
    },

    handleCohortSelect: (previous, current) => {
      dispatch(actions.selectCohort(
        current.data.id, 
        current.selected
      ));
    },

    handleParticipantGroupSelect: (type, id, element, group, selected) => {
      dispatch(actions.selectParticipantGroup(
        type,
        group,
        selected
      ));
    },

    handleLayersMenuItemChange: (id, element, group, selected) => {
      dispatch(actions.selectLayersMenuItem(
        selected
      ));
    },

    handleLayerChange: (previous, current) => {
      dispatch(actions.selectMeetingLayer(
        current.data.id, 
        current.selected
      ));
    },

    handleLabelChange: (item, e) => {
      dispatch(actions.selectMeetingLabel(
        item.id, 
        e.target.checked
      ));
    },

    handleMenuClearAllClick: (id) => {
      if(id === 'teachers') {
        dispatch(actions.unSelectTeachers());  
      }
      else if(id === 'cohorts') {
        dispatch(actions.unSelectCohorts());
      }
    },

    handleShareClick: () => {
      dispatch(actions.showModal(true));
    }
  };
};

export const ScheduleViewerContainer = React.createClass({

  componentDidMount: function() {
    this.props.handleMount();
  },

  componentWillUnmount: function() {
    document.body.removeEventListener('click', this.handleDocumentClick);
  },

  handleDocumentClick: function(e) {
    if(!this._isClickedInside) {
      this.props.dispatch(actions.hideOpenTrays());
      document.body.removeEventListener('click', this.handleDocumentClick);
    }
  },

  handleMenuMouseDown: function() {
    this._isClickedInside = true;
    document.body.addEventListener('click', this.handleDocumentClick);
  },

  handleMenuMouseUp: function(e) {
    this._isClickedInside = false;
  },

  render: function() {
    if(this.props.loading) {
      return <LoadingIndicator />;
    }
    else {
      return (
        <div className="abl-schedule-container">          
          <div className={`abl-schedule-viewer-grid ${this.props.className}`}>
            <div className="abl-schedule-controls">
              <div className="abl-schedule-controls-left">
                <ControlsMenu
                  {...this.props.controls}
                  onMenuItemChange={this.props.handleControlsMenuItemChange}
                  onDocumentClick={this.handleDocumentClick}
                  onTeacherSelect={this.props.handleTeacherSelect}
                  onCohortSelect={this.props.handleCohortSelect}
                  onParticipantGroupSelect={this.props.handleParticipantGroupSelect}
                  onMenuClearAllClick={this.props.handleMenuClearAllClick}
                  onMouseDown={this.handleMenuMouseDown} 
                  onClick={this.handleMenuMouseUp}
                />
              </div>
              <div className="abl-schedule-controls-middle">
                <SelectDropdown 
                className="abl-schedule-list"
                onChange={this.props.handleScheduleChange}
                items={this.props.schedules} />
              </div>
              <div className="abl-schedule-controls-right">
                <LayersMenu 
                  {...this.props.layers}
                  onMenuItemChange={this.props.handleLayersMenuItemChange}
                  onLayerChange={this.props.handleLayerChange}
                  onLabelChange={this.props.handleLabelChange}
                  onDocumentClick={this.handleDocumentClick}
                  onMouseDown={this.handleMenuMouseDown} 
                  onClick={this.handleMenuMouseUp} />
                <img 
                  className="abl-share-menu"
                  onClick={this.props.handleShareClick}
                  src={require('../../../img/svg/export_icon.svg')}
                  alt="Share"
                  width="16"
                  height="20"
                  />
              </div>
            </div>
            <div className="abl-schedule-content">
              <ViewerTable 
                onCellChange={this.props.handleCellChange}
                onColumnClick={this.props.handleColumnClick}
                onSubColumnClick={this.props.handleSubColumnClick}
                onColumnCloseClick={this.props.handleColumnCloseClick}
                onUnhideColumnsClick={this.props.handleUnhideColumnsClick}
                {...this.props.table} />
            </div>
          </div>
        </div>
      );
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleViewerContainer);


/** WEBPACK FOOTER **
 ** ./src/js/containers/schedule_viewer_container.js
 **/